import React from "react";
import Heading from "../../components/Heading";

import Slider from "react-slick";

import { Grid } from "@mui/material";

import elevator from "../../images/constructionalSlider/elevator.png";
import fors from "../../images/constructionalSlider/fors.png";
import interior from "../../images/constructionalSlider/interior.png";
import soler from "../../images/constructionalSlider/soler.png";
import styled from "@emotion/styled";
import { Container } from "@mui/material";

const H3 = styled.h3`
  position: absolute;
  top: 50px;
  left: 50px;
  font-weight: 800;
  color: #ffffff;
  @media (min-width: 1800px) {
    left: 180px;
  }
  @media (max-width: 599px) {
    top: 30px;
    font-size: 23px;
    text-align: left;
    left: 10px;
  } ;
`;

const Wrapper = styled.div`
  &:hover {
    transform: scale(1.1);
    width: 100%;
    transition: 0.3s ease-in;
  }
  @media (max-width: 1399px) {
    &:hover {
      transform: none;
      width: 100%;
      transition: none;
    }
  } ;
`;

const index = () => {
  var settings = {
    // dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,

    className: "center",
    centerPadding: "60px",
    slidesToShow: 3,
    swipeToSlide: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 799,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 599,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <div className="px-5" id="gallery">
      {/* <Container > */}
      <Heading mb599="40px" mb="50px" mt="50px" ml="50px">
        Construction
        <br /> Material
      </Heading>
      <Grid
        container
        textAlign="-webkit-center"
        justifyContent="center"
        alignItems="center"
      >
        <Grid xs={12}>
          <div>
            {/* <h2>Pause On Hover</h2> */}
            <Slider {...settings}>
              <div className="position-relative">
                <H3>For Elevator Lift</H3>
                <h3>
                  <Wrapper>
                    <img className="img-fluid" src={elevator} />
                  </Wrapper>
                </h3>
              </div>
              <div className="position-relative">
                <H3>For Structure</H3>
                <h3>
                  <Wrapper>
                    <img className="img-fluid" src={fors} />
                  </Wrapper>
                </h3>
              </div>
              <div className="position-relative">
                <H3>For Interior Designing</H3>
                <h3>
                  <Wrapper>
                    <img className="img-fluid" src={interior} />
                  </Wrapper>
                </h3>
              </div>
              <div className="position-relative">
                <H3>For Solar Energy Systems</H3>
                <h3>
                  <Wrapper>
                    <img className="img-fluid" src={soler} />
                  </Wrapper>
                </h3>
              </div>
            </Slider>
          </div>
        </Grid>
      </Grid>
      {/* </Container> */}
    </div>
  );
};

export default index;
